import React from "react";
import PortableText from "@sanity/block-content-to-react";
import { _localizeField } from "../../core/utils";
import SanityImage from "../SanityImage";

const Texte = ({ input }) => {
  // console.log(input);
  const serializers = {
    types: {
      block(props) {
        // console.log(props)
        switch (props.node.style) {
          // case "h1":
          //   return <h1>{props.children}</h1>
          default:
            return <p>{props.children}</p>;
        }
      },
      image: ({ node }) => {
        console.log(node);
        return (
          <div className='overflow-'>
            <div className='-mx-md'>
              <SanityImage input={node} />
            </div>
          </div>
        );
      },
    },
  };
  // console.log(input);
  const localizedText = _localizeField(input);
  if (!localizedText) console.log(input);
  return (
    <section className='texte portable-text'>
      {localizedText && (
        <PortableText blocks={localizedText} serializers={serializers} />
      )}
    </section>
  );
};

export default Texte;
